import React, { useEffect, useState, useRef, useCallback} from "react";
import Select from "react-select";
import './dashboard.css';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import { AgGridReact } from 'ag-grid-react';
import LoaderComponent from "../../../../../libraries/loader/loader";

import {baseUrl} from "../../../../../services/common/credentials";
import { port1 } from '../../../../../services/auth-service/authService';

import { Input } from 'semantic-ui-react';



var local_host = baseUrl + port1;


function ConsolidationReport() {
    const [inputMonth, setInputMonth] = useState(undefined);
    const [hideResultGrid, setHideResultGrid] = useState(true);
    const [loaderOpen, setLoaderOpen] = useState(false);
    // const [userCredentials] = useState(JSON.parse(sessionStorage.getItem("userCredentials")));
    const [rowData, setRowData] = useState([]);
    const [paginationSize] = useState(15);
    const [type, setType] = useState(undefined);
 

    var utr_columns = [
       
        { field: 'processing_month', headerName: 'processing_month', sortable: true, filter: true, resizable: true, editable: true },
        { field: 'file_type', headerName: 'file_type', sortable: true, filter: true, resizable: true },
        { field: 'num_of_rows', headerName: 'num_of_rows', sortable: true, filter: true, resizable: true },
        { field: 'total_amount', headerName: 'total_amount', sortable: true, filter: true, resizable: true },
        { field: 'satisfying_num_of_rows', headerName: 'satisfying_num_of_rows', sortable: true, filter: true, resizable: true },
        { field: 'satisfying_amount', headerName: 'satisfying_amount', sortable: true, filter: true, resizable: true },
        { field: 'output_num_of_rows', headerName: 'output_num_of_rows', sortable: true, filter: true, resizable: true },
        { field: 'output_total_amount', headerName: 'output_total_amount', sortable: true, filter: true, resizable: true },
        { field: 'sheet_name', headerName: 'sheet_name', sortable: true, filter: true, resizable: true },
        
    ];

    
    const OptionsList = [
        { value: "all", label: "all" },
        { value: "tax_invoice", label: "tax invoice"},
    ];

    useEffect(() => {
        setLoaderOpen(false);
    }, []);

    const makeAPICall = async (url) => {
        try {
            setLoaderOpen(true);
            
            const response = await fetch(url);
            const data = await response.json();
            setRowData(data);
            console.log('data', data);
            setHideResultGrid(false);
            setLoaderOpen(false);
        }
        catch (e) {
            console.log(e);
            setLoaderOpen(false);
            setHideResultGrid(true);
        }
    }
  
    

    const customStyles = {
        control: base => ({
            ...base,
            height: 35,
            minHeight: 35,
            marginTop: 0,
            paddingTop: -5,
            fontSize: 14,
        })
    };


    function searchClick(event) {
        if (type === undefined) {
            alert("Please Select Report Type!!!");
        }

        else{
            let url = '';
            console.log('companyname', type.value);
            let month = String(inputMonth)
            if (type && type.value && month) {
                let param = String(type.value)
                url = local_host+`/api/v2/user_modules/fetch_source_file_info/?type=${param}&&month=${month}`;
            }
           
            makeAPICall(url);
        }

    }
    

    function handleChange1(data) {
        setType(data);
        console.log('type',data.value);
        setHideResultGrid(true);
    }

    function onChangeMonth(e){
        setInputMonth(e.target.value);
        console.log(e.target.value);
    }


    return (
        <>
            <div className="report-cardBox">
                <div className="" style={{ marginLeft: "-10px" }}>
                    <div>
                        <label id="underline_select" htmlFor="underline_select " style={{ fontSize: '15px', marginLeft:'15px' }}>Date</label><br />
                        <Input type="month" className="cardName filetype" style={{ paddingLeft: "10px", marginTop:'5px' }} onChange={(e) => onChangeMonth(e)} />
                    </div>
                </div>
                <div style={{ marginLeft: "1.5em" }}>
                    <div>
                        <label htmlFor="underline_select " style={{ fontSize: '15px' }}> Select Type</label> <br />
                        <div className="cardName">
                            <div className="dropdown-container">
                                <Select
                                    options={OptionsList}
                                    placeholder="Select type"
                                    value={type}
                                    onChange={handleChange1}
                                    isSearchable={true}
                                    styles={customStyles}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                
               
                
                {inputMonth && type ?
                    <button className="btn" style={{ height: "35px", width: "92px", marginTop: "28px", backgroundColor: "#000055", color: "#ffffff" }} onClick={(e) => { searchClick(e) }}>Search</button>
                    : <button className="btn" disabled={true} style={{ height: "35px", width: "92px", marginTop: "28px", backgroundColor: "#000055", color: "#ffffff" }}>Search</button>
                }
            </div>
            
            <div className="report" hidden={hideResultGrid}>
                
                <div className="ag-theme-balham report-layer" style={{width:'100%', heidght:'100%'}}>
                    <AgGridReact
                        columnDefs={utr_columns}
                        rowData={rowData}
                        paginationPageSize={25}
                        pagination={true}
                        animateRows={true}
                        rowSelection={'multiple'}
                        groupSelectsChildren={true}
                        suppressAggAtRootLevel={true}
                        suppressRowClickSelection={true}
   
                    >
                    </AgGridReact>
                </div>
            </div>
          
            <LoaderComponent loaderOpen={loaderOpen} />

        </>
    )
}

export default ConsolidationReport;










